import React from 'react';
import '../ManageProjectsByEmployees.css';
import { useTranslation } from 'react-i18next';
import { formatStatCardFooterDate } from '../../../utils/timeUtils';

const OvertimeWorkStatOfSelectedProject = ({ startDate, endDate, totalDuration }) => {
    const { t } = useTranslation();

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                    <span>{t("employeeWorkDetails_overtime")}</span>
                    <span style={{ fontSize: '10px' }}>HH-MM-SS</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalDuration || '00:00:00'}
            </div>
            <div className='WorkStat-worked-footer'>
                {formatStatCardFooterDate(startDate)} to {formatStatCardFooterDate(endDate)}
            </div>
        </div>
    );
};

export default OvertimeWorkStatOfSelectedProject;
